if (!customElements.get('ht-shelf')) {
  class HtShelf extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.buttons = [...this.querySelectorAll('[data-dir]')];
      this.progress = this.querySelector('[data-progress]');
      if (!this.track || !this.buttons.length) return;

      this.addEventListener('click', this.#onClick);
      this.track.addEventListener('scroll', this.#update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.#update);
      this.resizeObserver.observe(this.track);
      this.#update();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
      this.track?.removeEventListener('scroll', this.#update);
      this.resizeObserver?.disconnect();
    }

    #onClick = (event) => {
      const button = event.target.closest('[data-dir]');
      if (!button) return;
      this.track.scrollBy({ left: Number(button.dataset.dir) * this.track.clientWidth * 0.85, behavior: 'smooth' });
    };

    #update = () => {
      const { scrollLeft, clientWidth, scrollWidth } = this.track;
      const [prev, next] = this.buttons;
      if (prev) prev.disabled = scrollLeft <= 4;
      if (next) next.disabled = scrollLeft + clientWidth >= scrollWidth - 4;

      // Optional progress bar: thumb width = visible share, position = scroll offset.
      if (this.progress && scrollWidth > 0) {
        const thumb = Math.min(1, clientWidth / scrollWidth);
        const pos = scrollWidth > clientWidth ? scrollLeft / (scrollWidth - clientWidth) : 0;
        this.progress.style.setProperty('--ht-thumb', thumb.toFixed(4));
        this.progress.style.setProperty('--ht-pos', ((pos * (1 - thumb)) / thumb).toFixed(4));
      }
    };
  }

  customElements.define('ht-shelf', HtShelf);
}
